import React, { useEffect, useMemo, useRef, useState } from "react";
import COUNTRIES, { COUNTRY_BY_CODE, flagUrl } from '../../pages/Profile/countries';
import './CountryPicker.scss';

export default function CountryPicker({ value, onChange, placeholder = 'اختر دولة…', id }) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);

    const sorted = useMemo(
        () => [...COUNTRIES].sort((a, b) => a[1].localeCompare(b[1], 'ar')),
        []
    );

    const filtered = useMemo(() => {
        const q = query.trim();
        if (!q) return sorted;
        const lq = q.toLowerCase();
        return sorted.filter(([code, name]) =>
            name.includes(q) || code.toLowerCase().includes(lq)
        );
    }, [sorted, query]);

    useEffect(() => {
        function onClick(e) {
            if (!wrapperRef.current?.contains(e.target)) setOpen(false);
        }
        function onKey(e) {
            if (e.key === 'Escape') setOpen(false);
        }
        document.addEventListener('mousedown', onClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onClick);
            document.removeEventListener('keydown', onKey);
        };
    }, []);

    useEffect(() => {
        if (open) inputRef.current?.focus();
        else setQuery('');
    }, [open]);

    const selectedName = value ? COUNTRY_BY_CODE[value] : '';
    const selectedFlag = value ? flagUrl(value) : null;

    return (
        <div className='cp' ref={wrapperRef}>
            <button
                type='button'
                id={id}
                className={'cp-control' + (open ? ' is-open' : '')}
                onClick={() => setOpen(o => !o)}
                aria-haspopup='listbox'
                aria-expanded={open}
            >
                {value ? (
                    <span className='cp-selected'>
                        <img
                            src={selectedFlag}
                            alt=''
                            className='cp-flag'
                            loading='lazy'
                            width='28'
                            height='21'
                        />
                        <span className='cp-selected-name'>{selectedName}</span>
                    </span>
                ) : (
                    <span className='cp-placeholder'>{placeholder}</span>
                )}
                <span className='cp-chevron' aria-hidden='true'>▾</span>
            </button>

            {open && (
                <div className='cp-popover' role='listbox'>
                    <input
                        ref={inputRef}
                        type='text'
                        className='cp-search'
                        placeholder='ابحث…'
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <ul className='cp-list'>
                        {value && (
                            <li>
                                <button
                                    type='button'
                                    className='cp-clear'
                                    onClick={() => { onChange(''); setOpen(false); }}
                                >
                                    إلغاء الاختيار
                                </button>
                            </li>
                        )}
                        {filtered.length === 0 && (
                            <li className='cp-empty'>لا توجد نتائج</li>
                        )}
                        {filtered.map(([code, name]) => (
                            <li key={code}>
                                <button
                                    type='button'
                                    className={'cp-option' + (code === value ? ' is-selected' : '')}
                                    onClick={() => { onChange(code); setOpen(false); }}
                                >
                                    <img
                                        src={flagUrl(code)}
                                        alt=''
                                        className='cp-flag'
                                        loading='lazy'
                                        width='28'
                                        height='21'
                                    />
                                    <span>{name}</span>
                                    <small className='cp-code'>{code}</small>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
